// Module
var code = "<div class=\"profile-address\">\n\n    <profile-address-favorite paf-locations=\"locations\"></profile-address-favorite>\n\n    <div class=\"text-align-left margin-top-15\">\n        <a class=\"vt-link vt-link_theme-yellow profile-address__manage-btn\" href=\"/profile/manage-locations\">Other saved\n            addresses</a>\n    </div>\n\n</div>";
// Exports
var _module_exports = code;;
var path = 'template/profile/address/profile-address.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;